import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import GameShowcase from './components/GameShowcase';
import FeaturesSection from './components/FeaturesSection';
import VipSection from './components/VipSection';
import ArticlePreview from './components/ArticlePreview';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '九游娱乐',
  url: 'https://www.jiuyouyule.com/',
  description: '九游娱乐是领先的在线娱乐平台，提供精品游戏、会员福利与顶级娱乐体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.jiuyouyule.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'https://www.jiuyouyule.com/',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '如何注册九游娱乐账号？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '点击网站右上角的"注册"按钮，填写手机号码并设置密码，完成短信验证后即可成功注册。整个注册过程仅需1分钟，注册即送新人大礼包。',
      },
    },
    {
      '@type': 'Question',
      name: '九游娱乐支持哪些支付方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们支持多种安全便捷的支付方式，包括：银行卡转账、微信支付、支付宝、USDT数字货币等。所有支付通道均经过严格安全认证，确保您的资金安全。',
      },
    },
    {
      '@type': 'Question',
      name: '游戏是否公平公正？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '九游娱乐所有游戏均采用国际认证的随机数生成器（RNG），确保每一局游戏结果完全随机、不可预测。我们定期接受第三方权威机构审计，游戏公平性有保障。',
      },
    },
    {
      '@type': 'Question',
      name: '提现需要多长时间到账？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '普通用户提现处理时间为1-2小时，VIP会员享受快速通道，提现最快10分钟到账。具体到账时间视银行处理速度略有差异，节假日正常处理。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系客服？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们提供7×24小时全天候客服服务。您可以通过在线客服、官方热线400-888-9999、或发送邮件至service@jiuyouyule.com联系我们。在线客服平均响应时间不超过30秒。',
      },
    },
  ],
};

export default function Home() {
  useDocumentMeta(
    '九游娱乐 - 官方娱乐平台，精彩游戏体验',
    '九游娱乐是您的首选在线娱乐平台，汇聚海量精品游戏、顶级娱乐内容与专属会员福利。安全、流畅、公平的游戏环境，7×24小时客服守护。'
  );

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <GameShowcase />
          <FeaturesSection />
          <VipSection />
          <ArticlePreview />
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}